import * as React from "react";
import Svg, { Path } from "react-native-svg";

const SvgComponent = (props) => {
  const { fill = "#FF2E00" } = props;
  return (
    <Svg
      width={19}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M18.605 13.773 11.893 1.37c-1.078-1.825-3.707-1.828-4.786 0L.395 13.773C-.707 15.638.627 18 2.788 18h13.424c2.159 0 3.496-2.36 2.393-4.227ZM9.5 15.762a1.118 1.118 0 0 1-1.113-1.12c0-.617.5-1.119 1.113-1.119.614 0 1.113.502 1.113 1.12 0 .616-.5 1.119-1.113 1.119Zm1.113-4.477c0 .617-.5 1.119-1.113 1.119a1.118 1.118 0 0 1-1.113-1.12V5.69c0-.617.5-1.12 1.113-1.12.614 0 1.113.503 1.113 1.12v5.596Z"
        fill={fill}
      />
    </Svg>
  );
};

export default SvgComponent;

// src/demo -> https://www.figma.com/file/toWmRphxElsfYAjBxNVQRx/CityMall-Customer-App?node-id=15868%3A3073
